import { create } from 'zustand';
import { devtools } from 'zustand/middleware';

import { type OrganizationUser } from '../../entity/api/organization-user';
import { createBasicStoreState } from './basic-store';

type TModel = OrganizationUser;

/**
 * Organization Users Zustand Store
 *
 * This store now only provides:
 * - Basic store methods (clearStore, updateToStore, updateMultipleToStore, etc.) for socket updates
 * - Sync state for socket handlers
 *
 * For data fetching and mutations, use TanStack Query hooks from organization-users-queries.ts:
 * - useOrganizationUsersList(orgId)
 * - useUserOrganizations()
 * - useOrganizationUsersByUserId(userId)
 * - useAllOrganizationUsers()
 * - useInviteUsersToOrganization()
 * - useManageOrganizationInvitation()
 * - useManageOrganizationUser()
 * - useRevokeInvite()
 * - useTransferOwnership()
 */
type FullStoreState = ReturnType<typeof createBasicStoreState<TModel>>;

export const useStore = create<FullStoreState>()(
  devtools(
    function (set, get) {
      return {
        ...createBasicStoreState<TModel>(set, get),
      };
    },
    { name: 'blym', store: 'organization-users' }
  )
);
